// Log store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  missingStrings: [],
};

export default {
  actions,
  mutations,
  getters,
  state,
};
